import { render, staticRenderFns } from "./ApiDocsFlux.vue?vue&type=template&id=ead9c5c0&scoped=true"
import script from "./ApiDocsFlux.vue?vue&type=script&lang=js"
export * from "./ApiDocsFlux.vue?vue&type=script&lang=js"
import style0 from "./ApiDocsFlux.vue?vue&type=style&index=0&id=ead9c5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead9c5c0",
  null
  
)

export default component.exports